import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

import { FetchAdvertisementBannerService } from 'src/app/dashboard/admin/action/components/banner/services/fetch-advertisement-banners.service';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
})
export class ImageSliderComponent implements OnInit {
  sliderArray: sliderImg[] = [];
  options: OwlOptions;
  constructor(private fetchAdvBanners: FetchAdvertisementBannerService) {
    this.options = {
      loop: true,
      mouseDrag: true,
      touchDrag: true,
      autoplay: true,
      autoplayTimeout: 10000,
      autoplaySpeed: 1000,
      items: 1,
      dots: false,
    };
  }
  async ngOnInit() {
    let response: any[] = await this.fetchAdvBanners.make();

    if (response.length > 0) {
      response = response
        .filter((res) => {
          return res.isHidden == false;
        })
        .sort((a, b) => a.order - b.order);
    }
    this.sliderArray = response;
  }
  onClickImage(link: string) {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(link)) {
      url += 'http://';
    }
    url += link;
    window.open(url, '_blank');
  }
}
export interface sliderImg {
  image: string;
  order?: number;
  isHidden?: boolean;
  href?: string;
}
